const apiConfig = {
  // apiUrl: "http://localhost:5656/api/v1"
  apiUrl: "https://api.varahiinfra.co/api/v1"
};

export default apiConfig;